import React, { useState } from "react";

const CircularChart = ({ data, size = 200, strokeWidth = 20, totalLeads }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    label: "",
    value: 0,
  });

  const handleMouseMove = (e, item) => {
    const rect = e.target.ownerSVGElement.getBoundingClientRect();
    setTooltip({
      visible: true,
      x: e.clientX - rect.left + 10,
      y: e.clientY - rect.top + 10,
      label: item.label,
      value: item.value,
    });
  };

  const handleMouseLeave = () => {
    setTooltip((t) => ({ ...t, visible: false }));
  };

  // ✅ Only non-zero values
  const filteredData = data.filter((d) => d.value > 0);
  const total = filteredData.reduce((s, d) => s + d.value, 0);

  // ✅ Precompute lengths + offsets
  let cumulative = 0;
  const segments = filteredData.map((item) => {
    const length = (item.value / total) * circumference;
    const segment = {
      ...item,
      length,
      offset: cumulative,
    };
    cumulative += length;
    return segment;
  });

  return (
    <div style={{ position: "relative", width: size }}>
      <svg width={size} height={size}>
        {/* Background ring */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          stroke="#E0E0E0"
          strokeWidth={strokeWidth}
        />

        {/* Segments */}
        {segments.map((item, index) => (
          <circle
            key={index}
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="transparent"
            stroke={item.color}
            strokeWidth={strokeWidth}
            strokeDasharray={`${item.length} ${circumference - item.length}`}
            strokeDashoffset={-item.offset}
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
            strokeLinecap="butt"
            onMouseMove={(e) => handleMouseMove(e, item)}
            onMouseLeave={handleMouseLeave}
            style={{ cursor: "pointer" }}
          />
        ))}

        {/* Center text */}
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dy="6"
          fontSize="16"
          fontWeight="bold"
        >
          Leads Touched
        </text>
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dy="24"
          fontSize="14"
          fill="#666"
        >
          {totalLeads}
        </text>
      </svg>

      {/* Tooltip */}
      {tooltip.visible && (
        <div
          style={{
            position: "absolute",
            left: tooltip.x,
            top: tooltip.y,
            background: "#333",
            color: "#fff",
            padding: "6px 10px",
            borderRadius: 4,
            fontSize: 12,
            pointerEvents: "none",
            whiteSpace: "nowrap",
          }}
        >
          <strong>{tooltip.label}</strong>
          <div>{tooltip.value}</div>
        </div>
      )}
    </div>
  );
};

export default CircularChart;
